export default "__VITE_ASSET__juShxEF$__"